import { create } from 'zustand';

interface UiState {
  sidebarOpen: boolean;
  uploadModalOpen: boolean;
  editingFieldId: string | null;
  editValue: string;
  setSidebarOpen: (open: boolean) => void;
  setUploadModalOpen: (open: boolean) => void;
  startEditing: (fieldId: string, currentValue: string) => void;
  stopEditing: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  sidebarOpen: true,
  uploadModalOpen: false,
  editingFieldId: null,
  editValue: '',
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  setUploadModalOpen: (open) => set({ uploadModalOpen: open }),
  startEditing: (fieldId, currentValue) =>
    set({ editingFieldId: fieldId, editValue: currentValue }),
  stopEditing: () => set({ editingFieldId: null, editValue: '' }),
}));
